import { Link } from "react-router-dom";

const HomeLink = () => {
  return (
    <Link
      to="/adq/home"
      className="flex items-center gap-2 text-lg font-semibold"
    >
      <img
        className="aspect-square rounded-md object-fit hover:cursor-pointer"
        src="/main-logo.svg"
        alt="ADQUIVER MEDIA"
        width={90}
      />
      <span className="sr-only">AdQuiver Media</span>
    </Link>
  );
};

export default HomeLink;
